import React from 'react';

const TermsOfUsePage = () => {
  return (
    <div className="py-16 px-4 bg-gray-50 min-h-screen">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-md p-8 md:p-12">
        <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">Terms of Use</h1>
        <p className="text-gray-500 text-sm mb-8">Last updated: March 2025</p>

        <div className="space-y-6 text-gray-600">
          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">1. Acceptance of Terms</h2>
            <p>By accessing or using the RDS College of Pharmacy website, you agree to be bound by these Terms of Use. If you do not agree, please do not use our site.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">2. Use of Content</h2>
            <p>All content on this site – including text, images, logos, and downloads – is the property of RDS College of Pharmacy and protected by copyright laws. You may not reproduce, distribute, or modify any content without prior written permission.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">3. User Conduct</h2>
            <p>You agree not to use the site for any unlawful purpose, to upload harmful code, or to interfere with the site’s operation. Any misuse may result in termination of access.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">4. Admission Information</h2>
            <p>While we strive for accuracy, information about courses, fees, and admissions may change. Please verify details with our admission office.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">5. Limitation of Liability</h2>
            <p>RDS College of Pharmacy is not liable for any damages arising from the use of this website, including but not limited to direct, indirect, or consequential losses.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">6. Links to Third Parties</h2>
            <p>Our site may contain links to external websites. We are not responsible for the content or practices of those sites.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">7. Changes to Terms</h2>
            <p>We reserve the right to update these terms at any time. Continued use of the site constitutes acceptance of the revised terms.</p>
          </section>

          <p className="pt-4 text-sm">For questions, contact <a href="mailto:rdspharmacycollege@gmail.com" className="text-blue-600 hover:underline">rdspharmacycollege@gmail.com</a>.</p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfUsePage;